import React from 'react';
import { CtaButton } from './CtaButton';
import { scatteredItems, workflowStages } from '../data/content';
export function ProblemSection() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-205" data-mp="2lq8hqrnk5uhb">
      <div className="mx-auto w-full max-w-3xl" data-id="element-206" data-mp="30hzi12evdwlw">
        <p className="text-center text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-cta" data-id="element-207" data-mp="2vqhh2ecujw0x">
          The real problem
        </p>

        <h2 className="mt-4 text-center text-[26px] font-black leading-[1.15] tracking-tight text-navy sm:text-4xl" data-id="element-208" data-mp="39guomfltt8pq">
          It’s not that you don’t have enough information.
          <span className="mt-2 block text-cta" data-id="element-209" data-mp="3jgljiieatpqc">
            It’s that your information is scattered everywhere.
          </span>
        </h2>

        <p className="mt-6 text-center text-[15px] font-semibold text-navy2 sm:text-lg" data-id="element-210" data-mp="3ehic4rauj7f7">
          How many things do you need to keep track of during an aligner case?
        </p>

        <ul className="mt-5 grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-211" data-mp="1k3zkfy3hyj1t">
          {scatteredItems.map(item => <li key={item} className="rounded-xl border border-navy/10 bg-white px-3 py-2.5 text-center text-[12.5px] font-semibold text-navy2 sm:text-sm" data-id="element-212" data-mp="jeoiieq5twpt">
              {item}
            </li>)}
        </ul>

        <p className="mt-6 text-center text-[15px] leading-relaxed text-navy2 sm:text-lg" data-id="element-213" data-mp="x51qgh31xbf5">
          And when that information is spread across courses, notes, PDFs,
          software, and different resources…{' '}
          <strong className="font-extrabold text-navy" data-id="element-214" data-mp="171mvh2f2mmiz">
            it’s easy to end up managing the case from memory.
          </strong>
        </p>

        <div className="mt-12 rounded-3xl bg-navy p-5 sm:p-9" data-id="element-215" data-mp="1bzy4xc1gev0o">
          <h3 className="text-center text-[22px] font-black leading-tight text-white sm:text-3xl" data-id="element-216" data-mp="1g22yybvtdtnu">
            What if you could organize the entire case first?
          </h3>

          <p className="mt-4 text-center text-[14.5px] leading-relaxed text-white/80 sm:text-base" data-id="element-217" data-mp="3htz85euierfg">
            That’s exactly what ALIGNER TREATMENT BLUEPRINT™ was designed to help
            you do. Instead of another long aligner textbook, you get a visual
            case-planning system that helps you organize the major stages of an
            aligner treatment.
          </p>

          <ol className="mt-7 grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-218" data-mp="tyu31vxog25m">
            {workflowStages.map((stage, index) => <li key={stage} className="flex items-center gap-2.5 rounded-xl border border-white/15 bg-white/5 px-3 py-3" data-id="element-219" data-mp="17y3942s65fvv" data-mpi={index}>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-sky text-[11px] font-black text-navy" data-id="element-220" data-mp="1hpfxulio7pxo">
                  {index + 1}
                </span>
                <span className="text-[12.5px] font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-221" data-mp="1qpct55zkfn1p">
                  {stage}
                </span>
              </li>)}
          </ol>

          <div className="mx-auto mt-8 max-w-md" data-id="element-222" data-mp="25cl01ulud67v">
            <CtaButton variant="onDark" label="Get the complete Blueprint" subLabel="One-time payment of $27 · Instant access" data-id="element-223" data-mp="25d4g15rxlkj9" />
          </div>
        </div>
      </div>
    </section>;
}